import PropTypes from 'prop-types';
import { useRef } from 'react';
import styles from './searchBanner.module.less';
import { trackEvent } from '../../support-and-tracking/analytics-actions';
import { useNavigate } from 'react-router';
import { InputTextLike } from '@sb1/ffe-form-react';

const SearchBanner = ({ theme = 'dark' }) => {
    const navigate = useNavigate();
    const searchInput = useRef(null);
    const classNames = [styles.container, theme === 'light' ? styles.light : styles.dark].join(' ');

    const search = (e) => {
        e.preventDefault();
        const value = searchInput?.current?.value;
        trackEvent('frontpage-search', 'submit', { theme, value });
        navigate(`/search?query=${encodeURIComponent(value)}`);
    };

    return (
        <form onSubmit={search} method="get" action={`/search`}>
            <label className={classNames}>
                <h2 className={styles.text}>Leter du etter en spesiell spleis?</h2>
                <div className={styles.searchContainer}>
                    <i className={['fa-solid fa-magnifying-glass', styles.icon].join(' ')} aria-hidden />
                    <InputTextLike
                        ref={searchInput}
                        className={styles.searchInput}
                        type="search"
                        name={'query'}
                        placeholder="Søk den opp her"
                        ariaLabel={'Søk opp en spleis'}
                    />
                </div>
            </label>
        </form>
    );
};

SearchBanner.propTypes = {
    theme: PropTypes.oneOf(['light', 'dark']),
};
SearchBanner.defaultProps = {
    theme: 'dark',
};

export default SearchBanner;
